import { DropdownTrigger } from 'components/dropdown/DropdownTrigger';
import { MediaQueries } from 'custom_hooks/useWindowSize';
import { dropdownTriggerStyles } from 'pages/Desk/issues/issue_modals/shared';
import styled, { css } from 'styled-components';
import { backgroundColor, borderColor, shadeBackgroundColor } from 'styles/theme';

const lightBackgroundStyle = css`
    border: 2px solid ${borderColor};
    border-width: 2px !important;
    background: ${shadeBackgroundColor};
`;

export const InputTrigger = styled(DropdownTrigger).attrs<{ $lightBackground?: boolean }>(
    {
        paddingOverride: '1.5y',
        style: dropdownTriggerStyles,
    }
)`
    background: ${backgroundColor};
    border-radius: 3px;
    margin-top: 0.5rem;

    position: relative;

    ${({ $lightBackground }) => ($lightBackground ? lightBackgroundStyle : '')};
`;

export const InputCurrentValue = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    gap: 0.5rem;
    flex-wrap: wrap;
    max-height: 12rem;
    overflow-y: auto;
`;

export const FaultTypePopupContentContainer = styled.div`
    box-sizing: border-box;
    flex-grow: 1;
    display: grid;
    grid-template-rows: auto 1fr auto;
    padding: 1rem;
    gap: 1rem;

    @media ${MediaQueries.mediumAndUp} {
        width: 40rem;
        grid-template-rows: auto 1fr auto;
    }
`;

export const FaultTypePopupContentTree = styled.div`
    overflow-y: auto;
    padding-right: 1rem;
    font-size: 1.4rem;
`;

export const FaultTypeTreeItem = styled.div<{ $isRoot: boolean }>`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0.6rem 0.6rem;
    font-weight: ${({ $isRoot }) => ($isRoot ? 'bold' : 'auto')};
    font-size: 1.4rem;
`;

export const FaultTypePopupContentFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 1rem;

    button {
        padding: 1rem;
    }
`;
